<template>
    <a-input-number
        v-model="changeValue"
        style="width: 100%"
        :min="parameters.min || parameters.min === 0 ? parameters.min : -Infinity"
        :max="parameters.max || parameters.max === 0 ? parameters.max : Infinity"
        :precision="parameters.precision"
        :step="parameters.step"
        :placeholder="parameters.placeholder"
        @blur="onBlurNumber()"
    >
    </a-input-number>
</template>

<script>
import { DataEntryMixin } from './mixins';

export default {
    name: 'SdNumber',
    mixins: [DataEntryMixin],
    methods: {
        // 是否可编辑
        isModify({ $props }){
            return Boolean($props.field.isModify);
        },
        // 失去焦点变0
        onBlurNumber(){
            if(this.parameters.min || this.parameters.min === 0){
                // 判断是否是数值
                if(Number(this.changeValue)){
                    this.$emit('update:value', this.changeValue > this.parameters.min ? this.changeValue : this.parameters.min);
                }
                else{
                    this.$emit('update:value', this.parameters.min);
                }
            }
        }
    }
};
</script>

<style scoped lang="less"></style>
